import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, of, switchMap, tap } from "rxjs";
import { AuthService } from "@core/services/auth.service";
import { AuthActions } from "./auth.actions";

@Injectable()
export class AuthEffects {
  private readonly actions$ = inject(Actions);
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.login),
      switchMap(({ payload }) =>
        this.auth.login(payload).pipe(
          map((res: any) => {
            const token =
              res?.data?.token ||
              res?.data?.accessToken ||
              res?.token ||
              res?.accessToken;
            const refreshToken = res?.data?.refreshToken || res?.refreshToken;
            const user = res?.data?.user || res?.user;

            if (!token) {
              return AuthActions.loginFailure({
                error: "No fue posible iniciar sesión",
              });
            }

            return AuthActions.loginSuccess({
              token,
              refreshToken,
              user,
            });
          }),
          catchError((err) =>
            of(
              AuthActions.loginFailure({
                error:
                  err.status === 400 || err.status === 401
                    ? "Correo o contraseña incorrectos"
                    : err?.error?.message || "No fue posible iniciar sesión",
              }),
            ),
          ),
        ),
      ),
    ),
  );

  loginSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActions.loginSuccess),
        tap(() => {
          this.router.navigate(["/dashboard"]);
        }),
      ),
    { dispatch: false },
  );

  logout$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActions.logout),
        tap(() => {
          this.auth.logout();
          this.router.navigate(["/auth/login"]);
        }),
      ),
    { dispatch: false },
  );
}
